var exports = {
  "kL": "xdbfd91f1--6f7912--container",
  "DP": "xdbfd91f1--6f7912--container-mobile",
  "vr": "xdbfd91f1--6f7912--icon-mobile",
};

module.exports = exports;
